// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"104d6d9a","726":"816655bb"}[chunkId] + ".chunk.js";
};